export enum Modes {
  BROWSE = 'browse',
  CREATE = 'create',
  UPDATE = 'update',
  UPLOAD = 'upload',
  DELETE = 'delete',
  CANCEL = 'cancel',
  PUBLISH = 'publish',
  FETCHING = 'fetching',
  WITH_ERROR = 'with_error',
}
